import { Tabs, Title } from "@mantine/core";
import clsx from "clsx";
import { useShareChatPanelState } from "./hooks/use-share-chat-panel-state";
import { PublishTabContent } from "./publish-tab-content";
import { ShareChatInviteForm } from "./share-chat-invite-form";
import type { ShareablePublication } from "./shareable-entity";

type ShareChatPanelContentProps = {
	chatId: string;
	chatName?: string;
	publication?: ShareablePublication | null;
};

export function ShareChatPanelContent({
	chatId,
	chatName = "Chat",
	publication,
}: ShareChatPanelContentProps) {
	const panel = useShareChatPanelState({
		chatId,
		publication,
	});

	return (
		<div>
			<div className="mb-4">
				<Title order={3}>Share Chat</Title>
			</div>

			<Tabs
				value={panel.activeTab}
				onChange={panel.setActiveTab}
				classNames={{
					root: "flex flex-col",
					list: "mb-2 border-b border-border-subtle",
					tab: clsx(
						"pb-3 pt-2 font-medium text-text-secondary hover:text-text-primary",
						"data-[active]:border-brand-primary data-[active]:text-brand-primary",
					),
					panel: "pt-1 pb-2",
				}}
			>
				<Tabs.List>
					<Tabs.Tab value="share">Share</Tabs.Tab>
					<Tabs.Tab value="publish" className="transition-colors duration-200">
						Publish
					</Tabs.Tab>
				</Tabs.List>

				<Tabs.Panel value="share">
					<ShareChatInviteForm chatId={chatId} />
				</Tabs.Panel>

				<Tabs.Panel value="publish">
					<PublishTabContent
						boardId={panel.documentId}
						isPublished={panel.isPublished}
						isLoading={panel.isLoading}
						permission={panel.permission}
						clipboardPublishedLink={panel.clipboardPublishedLink}
						entityName={chatName}
						entityLabel="chat"
						isLinkCopiedTooltipOpen={panel.isLinkCopiedTooltipOpen}
						onCopyTooltipTrigger={panel.handleCopyPublishLinkTooltip}
						onSwitchChange={panel.handleSwitchChange}
						onPermissionChange={panel.handlePermissionChange}
					/>
				</Tabs.Panel>
			</Tabs>
		</div>
	);
}
